/* src/app/modules_v2/booking/locations/components/sections/location-notifications-section/location-notifications-section.component.css */
.notif-section {
  padding: 1rem 1.5rem;
}
.block-title {
  font-size: 0.95rem;
  color: #111827;
  margin: 1.5rem 0 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #e5e7eb;
}
.row-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0;
  gap: 1rem;
  flex-wrap: wrap;
}
.row-toggle label {
  display: inline-flex;
  gap: 0.5rem;
  align-items: center;
  cursor: pointer;
  color: #374151;
  font-weight: 500;
  flex: 1;
  min-width: 220px;
}
.row-toggle input[type=checkbox] {
  width: 18px;
  height: 18px;
  accent-color: #f6c000;
}
.hours {
  display: inline-flex;
  gap: 0.4rem;
  align-items: center;
  color: #4b5563;
  font-size: 0.9rem;
}
.hours input[type=number] {
  width: 70px;
  padding: 0.35rem 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-family: inherit;
}
.actions {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
}
/*# sourceMappingURL=location-notifications-section.component.css.map */
